// External libraries
import { connect } from 'react-redux';
import { flowRight } from 'lodash';

// Zocdoc dependencies
import { withCustomMetrics } from '@zocdoc/frontend-metrics';
import { LOGIN_STATE } from '@zocdoc-frontend-common/state-user-account/constants';
import {
    loginStateSelector,
    userSelector,
} from '@zocdoc-frontend-common/state-user-account/selectors';
import { signInReset } from '@zocdoc-frontend-common/components-sign-in-form/signInFormActions';

// This package
import MobileMenu from './MobileMenu';

export function mapStateToProps(state) {
    const loginState = loginStateSelector(state);
    const hardOrSoftLoggedIn =
        loginState === LOGIN_STATE.LoggedIn ||
        loginState === LOGIN_STATE.SoftLoggedIn;
    return {
        signedIn: hardOrSoftLoggedIn,
        user: userSelector(state),
    };
}

const mapDispatchToProps = {
    resetLoginForm: signInReset,
};

export default flowRight(
    withCustomMetrics({
        component: 'MobileMenu',
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(MobileMenu);
